__turbopack_context__.v({
  "controlBar": "VideoPlayer-module-scss-module__InHMCG__controlBar",
  "controller": "VideoPlayer-module-scss-module__InHMCG__controller",
  "inlinePlayer": "VideoPlayer-module-scss-module__InHMCG__inlinePlayer",
  "media": "VideoPlayer-module-scss-module__InHMCG__media",
  "playButton": "VideoPlayer-module-scss-module__InHMCG__playButton",
  "playIcon": "VideoPlayer-module-scss-module__InHMCG__playIcon",
  "playIconWrapper": "VideoPlayer-module-scss-module__InHMCG__playIconWrapper",
  "stack-module-0": "VideoPlayer-module-scss-module__InHMCG__stack-module-0",
  "stack-module-1": "VideoPlayer-module-scss-module__InHMCG__stack-module-1",
  "stack-module-10": "VideoPlayer-module-scss-module__InHMCG__stack-module-10",
  "stack-module-11": "VideoPlayer-module-scss-module__InHMCG__stack-module-11",
  "stack-module-12": "VideoPlayer-module-scss-module__InHMCG__stack-module-12",
  "stack-module-13": "VideoPlayer-module-scss-module__InHMCG__stack-module-13",
  "stack-module-14": "VideoPlayer-module-scss-module__InHMCG__stack-module-14",
  "stack-module-15": "VideoPlayer-module-scss-module__InHMCG__stack-module-15",
  "stack-module-16": "VideoPlayer-module-scss-module__InHMCG__stack-module-16",
  "stack-module-17": "VideoPlayer-module-scss-module__InHMCG__stack-module-17",
  "stack-module-18": "VideoPlayer-module-scss-module__InHMCG__stack-module-18",
  "stack-module-19": "VideoPlayer-module-scss-module__InHMCG__stack-module-19",
  "stack-module-2": "VideoPlayer-module-scss-module__InHMCG__stack-module-2",
  "stack-module-20": "VideoPlayer-module-scss-module__InHMCG__stack-module-20",
  "stack-module-3": "VideoPlayer-module-scss-module__InHMCG__stack-module-3",
  "stack-module-4": "VideoPlayer-module-scss-module__InHMCG__stack-module-4",
  "stack-module-5": "VideoPlayer-module-scss-module__InHMCG__stack-module-5",
  "stack-module-6": "VideoPlayer-module-scss-module__InHMCG__stack-module-6",
  "stack-module-7": "VideoPlayer-module-scss-module__InHMCG__stack-module-7",
  "stack-module-8": "VideoPlayer-module-scss-module__InHMCG__stack-module-8",
  "stack-module-9": "VideoPlayer-module-scss-module__InHMCG__stack-module-9",
  "thumbnail": "VideoPlayer-module-scss-module__InHMCG__thumbnail",
  "thumbnailWrapper": "VideoPlayer-module-scss-module__InHMCG__thumbnailWrapper",
  "videoPlayer": "VideoPlayer-module-scss-module__InHMCG__videoPlayer",
  "z-base": "VideoPlayer-module-scss-module__InHMCG__z-base",
  "z-content": "VideoPlayer-module-scss-module__InHMCG__z-content",
  "z-footer": "VideoPlayer-module-scss-module__InHMCG__z-footer",
  "z-header": "VideoPlayer-module-scss-module__InHMCG__z-header",
  "z-hero": "VideoPlayer-module-scss-module__InHMCG__z-hero",
  "z-logo": "VideoPlayer-module-scss-module__InHMCG__z-logo",
  "z-logo-effect": "VideoPlayer-module-scss-module__InHMCG__z-logo-effect",
  "z-navigation": "VideoPlayer-module-scss-module__InHMCG__z-navigation",
  "z-sub": "VideoPlayer-module-scss-module__InHMCG__z-sub",
});
